import { saveAs } from "file-saver";
import { InfoMessage } from 'components';
import docSupDespDeclar from 'assets/documents/Υπεύθυνη Δήλωση Νόμιμου Εκπροσώπου_ΔΙΚ1.docx';

export const content = () =>
  [
    {
      label: 
      <p className={`mt-3 color-blue-3 text-bold font-size-24`}>
          Επισύναψη Αρχείου EE
        </p>,     
      fileCode: 'objectionEvaluation',
      id: 'objectionEvaluation',
      fileLimit: 10,
      multiple: true,
      required: false,
      fileAccepts: ['.pdf','.jpeg', '.jpg', '.png'],
    },
  ].filter(item => item);;
